export const DevisStatus = {
    InProgress: 'InProgress',
    Valid: 'Valid',
    Rejected: 'Rejected',
}

export const DevisStatusFR = {
    InProgress: 'En attente',
    Valid: 'Valide',
    Rejected: 'Rejeté',
}

export const DevisStatusList = [DevisStatus.InProgress, DevisStatus.Valid, DevisStatus.Rejected]